export const API_BASE = process.env.REACT_APP_BACKEND_URL;
console.log('📡 Using API base URL:', API_BASE);
